import { Tooltip as T } from 'radix-ui';
import type { ReactNode } from 'react';

export const TooltipProvider = T.Provider;

/** A small tooltip in the console's style; `content` null renders the child alone. */
export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  if (content === null || content === undefined || content === '') return <>{children}</>;
  return (
    <T.Root delayDuration={250}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          sideOffset={6}
          className="pl"
          style={{
            zIndex: 60,
            maxWidth: 320,
            padding: '6px 9px',
            borderRadius: 6,
            fontSize: 12,
            background: 'var(--color-surface-raised)',
            border: '1px solid var(--color-border-strong)',
            boxShadow: 'var(--shadow-pop)',
          }}
        >
          {content}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
